export function generateClientUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `cli-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}
